<template>
  <div
    style="font-family:Titillium Web;line-height: 1.0;"
    class="p-3 ml-1 mr-1  shadow-lg rounded-lg animate__animated animate__fadeIn "
      :style="`${$store.state.data.layout.background_card2}`"
  >
    <div class="row">
      <div class="col-12">
        <p class="pl-2 pt-2 text-lg font-semibold underline">My Services</p>
        <br>
      </div>
      <div class="col-12 p-2">
        <div class="row">
          <div 
           v-for="(item, index) in service" :key="index+'service'"
          class="col-sm-3 animate__animated animate__flipInY animate__delay-1s mt-3" :class="`order-${item.urutan}`">
            <div class="text-center">
             <button type="button" name="" id="" class="btn btn-sm btn-style8" :style="`background: rgb(64,180,231);
background: linear-gradient(0deg, rgba(64,180,231,1) 0%, rgba(1,29,108,1) 100%);`">
               <span class="typcn text-4xl text-white" :class="`${item.icon}`"></span>
             </button>
             <br>
             <br>
            </div>
           <p class="text-center font-bold  italic" style="font-size:15px;">{{item.title}}</p>
            <hr class="mt-1 mb-1"> <p
              class="text-center font-bold text-sm"
              style="font-size:13px;"
            >{{item.detail}}</p>
          </div>
        </div>
        <br />
      </div>
      <div class="col-12">
        <div v-if="$store.state.data.layout.skilltype=='1'">
          <Skill />
        </div>
        <div v-else-if="$store.state.data.layout.skilltype=='2'">
          <Skill2 />
        </div>
      </div>
      <br>
      <br>
      <br>
      <br>
<!--  -->
<br>
<div>
<div v-if="activity.length>0">
  <img :src="activity[0].gambar" v-viewer class="kinoLightBox img-fluid mt-5" alt="">
</div>

     <!-- <p class="p-3 font-times italic underline font-bold">MY STACKS</p> -->
      </div>
    </div>
    <h1 style="font-size:1px;opacity:0.1;">Portofolio TA_Maliki / Taufik Akbar Maliki PORTOFOLIO WEBSITE OFFICIAL</h1>
  </div>
</template>
<script>
import axios from 'axios'
// let rdb = firebase.database()
import autophp from '@/plugins/autophp'
let sdb = new autophp()
let urlnya='https://gis.officialapp.my.id'
import Skill from '@/components/portofolio/Skill.vue'
import Skill2 from '@/components/portofolio/Skill2.vue'
export default {
  components:{Skill,Skill2},
  data () {
    return {
      activity:[],
      service:[],

    }
  },
  layout: 'a-5',
  methods: {},
  mounted () {
     sdb.collection("app_portofolio_activity",false,urlnya).doc().select(`select * from app_portofolio_activity where iduser='${this.$store.state.id}'`).then(res => {
        this.activity=res;
        this.$forceUpdate();
    });
      sdb.collection("app_portofolio_service",false,urlnya).doc().select(`select * from app_portofolio_service where iduser='${this.$store.state.id}'`).then(res => {
        this.service=res;
        this.$forceUpdate();
    });
    
  },
}
</script>
<style scoped>
.progress {
  text-align: right;
  font-size: 14px;
  padding-top: 1px;
  padding-bottom: 10px;
  color: white;
  padding-right: 10px;
  padding-bottom: 4px;
}

/* <div class="row">
<div class="co3-6">
    <p class="p-2  text-sm font-bold animate__animated animate__flipInX ">HTML</p>
    <div style="width: 100%;background-color: #ddd;" class="rounded-lg shadow-lg animate__animated animate__flipInX ">
    <div
    class="progress bg-orange-400"
        style="width: 90%; "
    >90%</div>
    </div>
    <!--  -->
    <p class="p-2  font-bold animate__animated animate__flipInX ">CSS</p>
    <div style="width: 100%;background-color: #ddd;" class="rounded-lg shadow-lg animate__animated animate__flipInX ">
    <div
    class="progress bg-blue-400 pt-2"
        style="width: 90%;"
    >90%</div>
    </div>
    <!--  -->
        <p class="p-2  font-bold animate__animated animate__flipInX ">VUE.JS</p>
    <div style="width: 100%;background-color: #ddd;" class="rounded-lg shadow-lg animate__animated animate__flipInX ">
    <div
    class="progress bg-green-400  pt-2"
        style="width: 90%;"
    >90%</div>
    </div>
    <!--  -->
        <p class="p-2  font-bold animate__animated animate__flipInX ">JAVASCRIPT</p>
    <div style="width: 100%;background-color: #ddd;" class="rounded-lg shadow-lg animate__animated animate__flipInX ">
    <div
    class="progress bg-yellow-400"
        style="width: 90%;"
    >90%</div>
    </div>
    <!--  -->
    <p class="p-2  font-bold animate__animated animate__flipInX ">PUPETTER / WEB SCRAPING / AUTOMATION</p>
    <div style="width: 100%;background-color: #ddd;" class="rounded-lg shadow-lg animate__animated animate__flipInX ">
    <div
    class="progress bg-gray-400"
        style="width: 90%;"
    >90%</div>
    </div>
        <p class="p-2  font-bold animate__animated animate__flipInX ">FIREBASE / FIRESTORE / FUNCTION / DLL</p>
    <div style="width: 100%;background-color: #ddd;" class="rounded-lg shadow-lg animate__animated animate__flipInX ">
    <div
    class="progress bg-yellow-600"
        style="width: 90%;"
    >90%</div>
    </div>
    <!--  -->

        <p class="p-2  font-bold animate__animated animate__flipInX ">NODE.JS</p>
    <div style="width: 100%;background-color: #ddd;" class="rounded-lg shadow-lg animate__animated animate__flipInX ">
    <div
    class="progress bg-black"
        style="width: 90%;"
    >90%</div>
    </div>

    <!--  -->
</div>
<div class="col-6">
        <p class="p-2  font-bold animate__animated animate__flipInX ">PHP</p>
    <div style="width: 100%;background-color: #ddd;" class="rounded-lg shadow-lg animate__animated animate__flipInX ">
    <div
    class="progress "
        style="width: 90%;background:#777BB3;"
    >90%</div>
    </div>
        <p class="p-2  font-bold animate__animated animate__flipInX ">Nuxt.js</p>
    <div style="width: 100%;background-color: #ddd;" class="rounded-lg shadow-lg animate__animated animate__flipInX ">
    <div
    class="progress bg-green-700"
        style="width: 90%;"
    >90%</div>
    </div>
        <p class="p-2  font-bold animate__animated animate__flipInX ">Laravel</p>
    <div style="width: 100%;background-color: #ddd;" class="rounded-lg shadow-lg animate__animated animate__flipInX ">
    <div
    class="progress "
        style="width: 90%;background:#FF291A;"
    >90%</div>
    </div>
        <p class="p-2  font-bold animate__animated animate__flipInX ">SQL</p>
    <div style="width: 100%;background-color: #ddd;" class="rounded-lg shadow-lg animate__animated animate__flipInX ">
    <div
    class="progress "
        style="width: 90%;background:#2D7699;"
    >90%</div>
    </div>
        <p class="p-2  font-bold animate__animated animate__flipInX ">MONGODB</p>
    <div style="width: 100%;background-color: #ddd;" class="rounded-lg shadow-lg animate__animated animate__flipInX ">
    <div
    class="progress bg-green-200"
        style="width: 90%;"
    >90%</div>
    </div>
        <p class="p-2  font-bold animate__animated animate__flipInX ">NEDB</p>
    <div style="width: 100%;background-color: #ddd;" class="rounded-lg shadow-lg animate__animated animate__flipInX ">
    <div
    class="progress bg-orange-200"
        style="width: 90%;"
    >90%</div>
    </div>
    <p class="p-2  font-bold animate__animated animate__flipInX ">GIT</p>
    <div style="width: 100%;background-color: #ddd;" class="rounded-lg shadow-lg animate__animated animate__flipInX ">
    <div
    class="progress bg-gray-700"
        style="width: 90%;"
    >90%</div>
    </div>
</div> */
</style>
